import { isObject as _isObject } from 'vuetify/es5/util/helpers'
import { get, isEmpty, isNumber } from 'lodash'
import axios from 'axios'
import store, { persistentes } from '../store'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import { StatusVendaNaoGerada, StatusPagamentosPagos, StatusVendaCanceladas, StatusContrato, ErrorsThatCannotBeShow, StatusContratoDesc } from './constants'
import { ERROR_NEWCON_FORA_DO_AR, ErrorsASeremSubstituidos } from './errors_to_replace'

export function deepFreeze (object) {
  // Retrieve the property names defined on object
  const propNames = Object.getOwnPropertyNames(object)

  // Freeze properties before freezing self
  for (let name of propNames) {
    let value = object[name]
    object[name] = value && typeof value === 'object' ? deepFreeze(value) : value
  }

  return Object.freeze(object)
}

export function mapStateless (keys) {
  const computed = {}
  keys.forEach(name => {
    computed[name] = {
      get () {
        return this.value[name]
      },
      set (value) {
        this.$emit('input', { ...this.value, [name]: value })
      }
    }
  })
  return computed
}

export function watchAll (keys, handler) {
  const watchers = {}
  keys.forEach(key => {
    watchers[key] = handler
  })
  return watchers
}

export function swap (array, a, b) {
  const arr = [...array]
  const tmp = arr[a]
  arr[a] = arr[b]
  arr[b] = tmp
  return arr
}

export const unmask = v => {
  if (!v) {
    return ''
  }
  return v.replace(/[^\d]+/g, '')
}

export const sleep = delay => new Promise(resolve => setTimeout(resolve, delay))

export const notification = (type, errorOrMessage, erro_padrao = '', transformInHtml = false, icon = false, startPaused = false) => {
  let errorMessage = ''

  if (type === 'error' && errorOrMessage.response && errorOrMessage.response.status === 401 && errorOrMessage.response.data.Msg_Erro === 'Token not provided') {
    errorMessage = 'Caro usuário, seu token de autenticação expirou. Por favor, faça login novamente para gerar um novo token de autenticação.'
  } else if (type === 'error' && typeof errorOrMessage === 'object' && errorOrMessage.response && errorOrMessage.response.data && (errorOrMessage.response.data.Msg || errorOrMessage.response.data.Msg_Erro || errorOrMessage.response.data.Msg_Error || errorOrMessage.response.data.Err_Msg)) {
    errorMessage = errorOrMessage.response.data.Msg || errorOrMessage.response.data.Msg_Erro || errorOrMessage.response.data.Msg_Error || errorOrMessage.response.data.Err_Msg || erro_padrao
  } else {
    errorMessage = errorOrMessage || erro_padrao
  }

  if (typeof errorMessage === 'string') {
    errorMessage = errorMessage.replace('Error:', '')
  }

  if (typeof errorMessage === 'string') {
    errorMessage = errorMessage.replace('Error:', '').trim()
  }

  if (checkErrorMessage(errorMessage, ERROR_NEWCON_FORA_DO_AR)) {
    errorMessage = `${ErrorsASeremSubstituidos[ERROR_NEWCON_FORA_DO_AR](ERROR_NEWCON_FORA_DO_AR)}`
  }

  let errorOrMessageToVerify = null
  if (errorMessage.message) {
    errorOrMessageToVerify = errorMessage.message
  } else if (typeof errorMessage === 'string') {
    errorOrMessageToVerify = errorMessage
  }
  if (typeof errorOrMessageToVerify === 'string') {
    const naoPodeSeguir = ErrorsThatCannotBeShow.find(message => errorOrMessageToVerify.includes(message))
    if (naoPodeSeguir) {
      return
    }
  }

  errorMessage = formatAlertText(errorMessage, transformInHtml)

  const payload = { type: type, message: errorMessage, icon: icon, transformInHtml: transformInHtml, startPaused: startPaused }
  store.commit('notificationShow', payload)
}

export function checkErrorMessage (completeMsg, newconErrorMesage) {
  if (typeof completeMsg !== 'string') {
    completeMsg = completeMsg.message
  }
  if (typeof completeMsg !== 'string') {
    return false
  }
  return completeMsg.includes(newconErrorMesage) || false
}

export const alert = (options, handler) => {
  if (!isObject(options) && handler) {
    options = {
      text: options,
      buttons: { OK: { focus: true, handler } }
    }
  }

  store.commit('alertShow', options)
}

export async function asyncAlert (text) {
  return new Promise(resolve => {
    alert({
      text,
      buttons: {
        OK: resolve
      }
    })
  })
}

export async function asyncConfirmationDialog (text) {
  return new Promise(resolve => {
    alert({
      text,
      buttons: {
        Sim: () => resolve(true),
        Fechar: () => resolve(false)
      }
    })
  })
}

export const isObject = _isObject

export function formatToMoreThanOneDecimal (value) {
  if (value < 9) {
    return '0' + value
  } else {
    return value + ''
  }
}

export const error = (err, defaultMsg) => {
  if (!axios.isCancel(err)) {
    const msg = get(err, 'response.data.Msg_Erro', defaultMsg)
    alert(msg || defaultMsg)
  }
}

export function toDate (data) {
  if (data.indexOf(' ') !== -1) {
    let d = data.split(' ')
    data = d[0]
  } else {
    if (data.indexOf('T') !== -1) {
      let d = data.split('T')
      data = d[0]
    }
  }

  return data
}

export function toDateFormatUS (data) {
  if (!isEmpty(data)) {
    if (isNumber(data)) {
      data = data.toString().replace(/^([0-9]{4})([0-9]{2})([0-9]{2})$/, '$1-$2-$3')
    } else {
      data = toDate(data)
    }

    if (data.indexOf('/') !== -1) {
      let d = data.split('/')

      data = d[2] + '-' + d[1] + '-' + d[0]
    }
  }

  return data
}

export function toDateFormatBrWithHour (data) {
  return moment(data).format('DD/MM/YYYY H:m:s')
}

export function capitalizeString (string) {
  return string.replace(/(^\w{1})|(\s+\w{1})/g, string => string.toUpperCase())
}
export function toDateFormatBR (data) {
  if (!isEmpty(data)) {
    if (isNumber(data)) {
      data = toDateFormatUS(data)
    } else {
      data = toDate(data)
    }

    if (data.indexOf('-') !== -1) {
      let d = data.split('-')

      data = d[2] + '/' + d[1] + '/' + d[0]
    }
  }
  return data
}

/**
 * Remove zeros à esquerda caso o valor seja numérico
 * @param value
 * @returns string|int
 */
export function trimZeros (value) {
  return isNaN(value) ? value : parseInt(value)
}

/**
 * Pega as chaves de tudo que persiste na sessão.
 * @returns {Array}
 */
export function getKeysOfPersistentes () {
  const chaves = Object.keys(persistentes)
  return chaves
}

export function findUnidade (unidade_procurada, empresa_procurada, unidades, backoffice) {
  try {
    return unidades.find(unidade => (unidade.id_unidade_negocio === unidade_procurada || unidade.cd_unidade_negocio === unidade_procurada) && (unidade.id_empresa === empresa_procurada || backoffice)) || null
  } catch {
    return null
  }
}

export function findUnidadeMultiplasEmpresas (unidade_procurada, unidades, empresas_permitidas, backoffice) {
  try {
    for (const empresa_procurada of empresas_permitidas) {
      const unidade_encontrada = unidades.find(unidade => (unidade.id_unidade_negocio === unidade_procurada || unidade.cd_unidade_negocio === unidade_procurada) && (unidade.id_empresa === empresa_procurada || backoffice))

      if (unidade_encontrada) {
        return unidade_encontrada
      }
    }
    return null
  } catch {
    return null
  }
}

export function pegaNumeroAteSegundaVirgula (num) {
  return Math.floor(num * 100) / 100
}

export function getNomeEmpresaPorIdEmpresa (id_empresa) {
  if (id_empresa === 1) {
    return 'Rodobens'
  } else if (id_empresa === 3) {
    return 'Portobens'
  } else if (id_empresa === 10) {
    return 'Br Qualy'
  } else if (id_empresa === 15) {
    return 'CNF'
  } else if (id_empresa === 300) {
    return 'ConBr'
  } else {
    return ''
  }
}

export function isEmptyHelper (valor) {
  if (Array.isArray(valor) || typeof valor === 'string') {
    return valor.length === 0
  } else if (typeof valor === 'object' && valor !== null) {
    return Object.keys(valor).length === 0
  } else {
    return isNaN(valor) ? valor : !(valor > 0)
  }
}

export function GetStepsPolitica (exibirAssinaturaContrato, exibirContratoAlocacao, permiteMultiplicarCotas) {
  let Steps = [{ icon: 'rod-produto', text: 'Produto' }, { icon: 'rod-grupo', text: 'Grupo' }, { icon: 'rod-cadastro', text: 'Cadastro' }, { icon: 'ol-book', text: 'Confirmação' }, { icon: 'gesture', text: 'Contrato' }, { icon: 'rod-cartao', text: 'Pagamento' }]
  if (permiteMultiplicarCotas) {
    Steps.splice(3, 0, { icon: 'mdi-cart-variant', text: 'Cotas' })
  }
  if (exibirAssinaturaContrato && exibirContratoAlocacao) {
    Steps = swap(Steps, 4, 5)
  }
  return Steps
}

export function calcPercentage (valor, valorTotal) {
  return valor / (valorTotal / 100)
}

export function encrypt (login, valueEncrypt, keySecret) {
  return CryptoJS.AES.encrypt(valueEncrypt, login + keySecret).toString()
}

export function decrypt (login, valueDecrypt, keySecret) {
  const bytesDescriptografados = CryptoJS.AES.decrypt(valueDecrypt, login + keySecret)
  return bytesDescriptografados.toString(CryptoJS.enc.Utf8)
}

export function isVendaNaoGerada (status_pedido) {
  return StatusVendaNaoGerada.includes(status_pedido)
}
export function isVendaCancelada (status_pedido) {
  return StatusVendaCanceladas.includes(status_pedido)
}

export function verifyIfPaidAndReturnInText (status_pedido) {
  if (status_pedido) {
    return StatusPagamentosPagos.includes(status_pedido) ? 'Pago' : 'Não Pago'
  } else {
    return '-'
  }
}

export function verifyIfPaidAndReturnInBool (status_pedido) {
  if (status_pedido) {
    return !!StatusPagamentosPagos.includes(status_pedido)
  } else {
    return false
  }
}

export function isSigned (status_contrato) {
  return StatusContrato.ContratoAssinado === status_contrato
}

export function replaceUndefinedKeysWithNull (obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && typeof obj[key] === 'undefined') {
      obj[key] = null
    }
  }
  return obj
}

export function existHierarchy (value) {
  return typeof value !== 'undefined' && !isEmptyHelper(value)
}

export function getComissionadoNormalized (id_comissionado, comissionados_sessao, backoffice) {
  if (backoffice) {
    const comissionado = comissionados_sessao.find(comissionado => comissionado.id_comissionado === id_comissionado)
    return { id_comissionado: id_comissionado, cd_comissionado: comissionado.cd_comissionado, nm_comissionado: comissionado.nm_comissionado, nm_pessoa: comissionado.nm_pessoa }
  } else {
    comissionados_sessao = formatarComissionadosHierarquia(comissionados_sessao)
    const comissionado = comissionados_sessao.find(comissionado => comissionado.ID_Comissionado === id_comissionado)
    return { id_comissionado: id_comissionado, cd_comissionado: comissionado.CD_Comissionado, nm_comissionado: comissionado.NM_Comissionado, nm_pessoa: comissionado.NM_Pessoa }
  }

  function formatarComissionadosHierarquia (comissionados) {
    return comissionados.map(item => {
      if (item.idComissionado) {
        return { ID_Comissionado: item.idComissionado, CD_Comissionado: item.codigoComissionado, NM_Comissionado: item.nomeComissionado, NM_Pessoa: item.nomeComissionado }
      }
      return item
    })
  }
}

export function limparEspacosAsteriscos (str) {
  if (str) {
    return str.replace(/[\s*]/g, '')
  }
  return ''
}

export function apagarTextoApos (texto, palavraChave) {
  var indice = texto.indexOf(palavraChave)
  if (indice !== -1) {
    return texto.slice(0, indice) + palavraChave
  } else {
    return texto
  }
}

export function findClosestIndex (array, term, key) {
  const termInt = parseInt(term)
  let left = 0
  let right = array.length - 1
  let proximaIndex = null
  let anteriorIndex = null

  while (left <= right) {
    const mid = Math.floor((left + right) / 2)
    const midValue = array[mid][key]

    if (midValue >= termInt) {
      proximaIndex = mid
      right = mid - 1
    } else {
      anteriorIndex = mid
      left = mid + 1
    }
  }

  return proximaIndex !== null ? proximaIndex : anteriorIndex
}

export function formatAlertText (text, transformInHtml) {
  if (typeof text === 'string') {
    return transformInHtml ? text.replace(/\n/g, '<br/>') : text.replace(/<br\/>/g, '\n')
  }
  return text
}

export function getDescricaoStatusContrato (status_banco, docusign_falha, docusign_enviado) {
  const status = getStatusContrato(status_banco, docusign_falha, docusign_enviado)
  return StatusContratoDesc[status]
}

export function getStatusContrato (status_banco, docusign_falha, docusign_enviado) {
  let status = status_banco
  if (!docusign_enviado && docusign_falha) {
    status = 'Falha'
  } else {
    status = status || StatusContrato.ContratoEmEspera
  }
  return status
}

export function formatarMoedaBrl (valor) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor)
}

export function formatTempoRestante (tempo) {
  const m = Math.floor(tempo / 60).toString().padStart(2, '0')
  const s = (tempo % 60).toString().padStart(2, '0')
  return `${m}:${s}`
}
